<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'inventory-finishedInbound',
  components: {
    PageTable,
  },
}
</script>